'use strict';

var cov_1iy1kfj3dv = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.projects.factory.js',
        hash = '08e79cce163ff17d955951b6b2d481d80664f2a1',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/shared/js/ORM/tables.projects.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 19,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 50
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 19,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1iy1kfj3dv.s[0]++;
(function () {
    'use strict';

    cov_1iy1kfj3dv.f[0]++;
    cov_1iy1kfj3dv.s[1]++;
    angular.module('app').factory('ProjectsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_1iy1kfj3dv.f[1]++;
        cov_1iy1kfj3dv.s[2]++;


        return restmod.model('/projects').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            }
        });
    }
})();